angular.module('autoremind.directives')
    .directive('ngClickCopy', ['ngCopy', '$timeout', function (ngCopy, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var div = angular.element('<div class="text-center copyBox">Copied</div>');
                element.parent().append(div);
                div.hide();
                var cb = function () {
                    div.show();
                    $timeout(function () {
                        div.hide();
                    }, 1600);
                };
                element.bind('click', function (e) {
                    ngCopy(attrs.ngClickCopy, cb);
                });
            }
        };
    }])
    .service('ngCopy', ['$window', function ($window) {
        var body = angular.element($window.document.body);
        var textarea = angular.element('<textarea/>');
        textarea.css({
            position: 'fixed',
            opacity: '0'
        });
        return function (toCopy, cb) {
            textarea.val(toCopy);
            body.append(textarea);
            textarea[0].select();
            window.prompt("You need to copy to clipboard manually (Ctrl+C, Enter on Windows and cmd+C on Mac)", toCopy);
            try {
                var successful = document.execCommand('copy');
                if (!successful)
                    throw successful;
            }
            catch (err) {
                window.prompt("You need to copy to clipboard manually (Ctrl+C, Enter on Windows and cmd+C on Mac)", toCopy);
            }
            textarea.remove();
            cb();
        };
    }]);
//# sourceMappingURL=ng-click-copy.directive.js.map